import {defineStore, type StoreDefinition} from "pinia";
import type {ToastStoreState} from "~/store/toast/state";
import type {ToastStoreActions} from "~/store/toast/actions";
import {state} from "~/store/toast/state";
import {actions} from "~/store/toast/actions";

export type ToastStoreType = StoreDefinition<string, ToastStoreState, any, ToastStoreActions>;

export const useToastStore: ToastStoreType = defineStore('toastStore', {
    state,
    actions
});
